var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { collection } from "firebase/firestore";
import { format } from "@formkit/tempo";
import { db } from "../firebase";
import { searchAPI } from "../API/api";
import { v4 as uuidv4 } from 'uuid';
import { firebasePath } from "../constants/constants";
export function createChatList(data) {
    const chatsArray = [];
    let key;
    for (key in data) {
        chatsArray.push(data[key]);
    }
    return chatsArray.sort((a, b) => {
        const dateOneToSecond = a.dateOfChange
            ? Date.parse(a.dateOfChange.replace(/"/g, ""))
            : 0;
        const dateTwoToSecond = b.dateOfChange
            ? Date.parse(b.dateOfChange.replace(/"/g, ""))
            : 0;
        if (dateOneToSecond < dateTwoToSecond)
            return 1;
        else if (dateOneToSecond > dateTwoToSecond)
            return -1;
        else
            return 0;
    });
}
export function createMessageList(list) {
    const messagesArray = [];
    let key;
    for (key in list) {
        messagesArray.push(list[key]);
    }
    const sort = messagesArray.sort((a, b) => {
        const dateOneToSecond = Date.parse(String(new Date(JSON.parse(a.date))));
        const dateTwoToSecond = Date.parse(String(new Date(JSON.parse(b.date))));
        if (dateOneToSecond < dateTwoToSecond)
            return -1;
        else if (dateOneToSecond > dateTwoToSecond)
            return 1;
        else
            return 0;
    });
    return sort;
}
export function scrollToElement(element, list, currentUserID, firstRender) {
    var _a;
    let targetID = list[list.length - 1].messageID;
    if (firstRender) {
        for (let i = 0; i < list.length; i++) {
            if (list[i].sender.uid !== currentUserID && i && ((_a = list[i + 1]) === null || _a === void 0 ? void 0 : _a.read) === false) {
                targetID = list[i].messageID;
                break;
            }
        }
    }
    if (element) {
        const targetElement = element.querySelector(`label[data-id="${targetID}"]`);
        targetElement.scrollIntoView({ block: 'end', behavior: firstRender ? 'auto' : 'smooth' });
    }
}
export function createNewDate(now) {
    //const now = new Date()
    // const date = now.toLocaleDateString()
    // const hours = now.getHours();
    // const minutes = now.getMinutes();
    // const seconds = now.getSeconds();
    // const time = `${hours}:${minutes}:${seconds}`
    const date = format(JSON.parse(now), { date: "short" });
    const time = format(JSON.parse(now), { time: "medium" });
    return `${date} ${time}`;
}
export function getTimeFromDate(date) {
    return date.split(' ')[1].split(':').slice(0, 2).join(':');
}
export function getDatefromDate(date) {
    return date.split(' ')[0];
}
function escapeHtml(text) {
    return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}
export function checkMessage(str) {
    const reg = /(https?:\/\/|ftps?:\/\/|www\.)((?![.,?!;:()]*(\s|$))[^\s]){2,}/im;
    const imageExtReg = /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i;
    const youtubeRegex = /(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([\w-]{11})(?:\S+)?/i;
    const imgUrls = [];
    const YTUrls = [];
    let hasLink = false;
    const lines = str.split('\n');
    const processedLines = lines.map((line) => {
        const words = line.split(/\s+/);
        const processedWords = words.map((item) => {
            var _a;
            const escaped = escapeHtml(item);
            if (reg.test(item)) {
                hasLink = true;
                const isYTlink = item.match(youtubeRegex);
                if (isYTlink && isYTlink[1]) {
                    const videoId = isYTlink[1];
                    const YTUrl = `https://www.youtube.com/embed/${videoId}`;
                    YTUrls.push(YTUrl);
                }
                if (imageExtReg.test(item) &&
                    YTUrls.indexOf(`https://www.youtube.com/embed/${(_a = item.match(youtubeRegex)) === null || _a === void 0 ? void 0 : _a[1]}`) === -1) {
                    imgUrls.push(item);
                }
                const url = item.startsWith('www.') ? `http://${item}` : item;
                return `<a href="${escapeHtml(url)}" target="_blank" rel="noopener noreferrer">${escaped}</a>`;
            }
            return escaped;
        });
        return processedWords.join(' ');
    });
    const finalMessage = processedLines.join('<br />');
    return { message: finalMessage, imgUrls, YTUrls, hasLink };
}
export function getQuantityNoReadMessages(messages, currentId) {
    let quantity = 0;
    let targetIndex = -1;
    for (let i = 0; i < messages.length; i++) {
        const msg = messages[i];
        const isUnread = msg.read === false;
        const isFromOtherUser = msg.sender.uid !== currentId;
        if (isUnread && isFromOtherUser) {
            quantity++;
            if (targetIndex === -1) {
                targetIndex = i;
            }
        }
    }
    if (quantity === 0) {
        targetIndex = messages.length > 0 ? messages.length - 1 : -1;
    }
    return { targetIndex, quantity };
}
export function searchMessagesInList(array, substring) {
    const lowerSubstring = substring.toLowerCase();
    return array.reduce((indicesSet, item, index) => {
        if (item.message.toLowerCase().includes(lowerSubstring)) {
            indicesSet.add(index);
        }
        return indicesSet;
    }, new Set());
}
export function getChatType(isFavorites, selectedChat) {
    if (isFavorites)
        return collection(db, selectedChat.email, firebasePath.FAVORITES, 'message');
    if (selectedChat === null || selectedChat === void 0 ? void 0 : selectedChat.channel)
        return collection(db, firebasePath.CHANNELS, selectedChat.channel.channelID, 'messages');
    return collection(db, firebasePath.CHATS, selectedChat.chatID, 'messages');
}
export function makeChatId(users) {
    return [users.currentUser.uid, users.guestInfo.uid].sort().join('_');
}
export function getFakeChat(id) {
    return ({
        displayName: '',
        uid: '',
        email: '',
        chatID: id
    });
}
export function createBaseMessageObject(message) {
    return ({
        message: message.message,
        messageID: message.messageID,
        date: message.date,
        sender: {
            displayName: message.sender.displayName,
            email: message.sender.email,
            uid: message.sender.uid
        }
    });
}
export function createBaseObjectChannel(channel) {
    return ({
        displayName: channel.displayName,
        channelID: channel.channelID,
        isOpen: channel.isOpen,
        owner: {
            displayName: channel.owner.displayName,
            email: channel.owner.email,
            uid: channel.owner.uid
        }
    });
}
export function globalSearch(name, currentUserID) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield Promise.all([searchAPI.searchUser(name), searchAPI.searchChannel(name)]);
        const chats = response[0].filter(item => item.uid !== currentUserID);
        const channel = response[1];
        const channelToChat = channel.map(item => ({ uid: item.channelID, displayName: item.displayName, email: item.owner.email, channel: item, chatID: item.channelID }));
        return [...chats, ...channelToChat].sort((a, b) => String(a.displayName).localeCompare(String(b.displayName)));
    });
}
function removeUndefinedDeep(obj) {
    if (obj !== Object(obj)) {
        return obj;
    }
    const entries = Object.entries(obj)
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => [key, removeUndefinedDeep(value)]);
    return Object.fromEntries(entries);
}
// export function createObjectChannel(chat: TypeChannel): Chat {
//     return ({
//         displayName: chat.displayName,
//         email: chat.owner.email,
//         chatID: chat.channelID,
//         uid: chat.channelID,
//         dateOfChange: chat.dateOfChange,
//         channel: chat
//     })
// }
export function createObjectChannel(chat) {
    return removeUndefinedDeep({
        displayName: chat.displayName,
        email: chat.owner.email,
        chatID: chat.channelID,
        uid: chat.channelID,
        dateOfChange: chat.dateOfChange,
        channel: chat
    });
}
export function createOnlineStatusUser(date) {
    const currentDate = Date.now();
    const isOnline = currentDate - date < 60000 ? true : false;
    return ({ isOnline, last_seen: date });
}
export function convertBackChannelToClient(data) {
    var _a;
    const listOfSubscribers = Object.values((_a = data === null || data === void 0 ? void 0 : data.listOfSubscribers) !== null && _a !== void 0 ? _a : {});
    return (Object.assign(Object.assign({}, data), { listOfSubscribers }));
}
export function getContextMenuPosition(options) {
    const { clickX, clickY, menuWidth, menuHeight } = options;
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
    let left;
    let top;
    if (clickX + menuWidth <= screenWidth) {
        left = clickX;
    }
    else {
        left = clickX - menuWidth;
        if (left < 0)
            left = screenWidth - menuWidth;
    }
    if (clickY + menuHeight <= screenHeight) {
        top = clickY;
    }
    else {
        top = clickY - menuHeight;
        if (top < 0)
            top = screenHeight - menuHeight;
    }
    return { top, left };
}
export function aggregateReactions(reactions, currentUser) {
    const reactionMap = new Map();
    if (!reactions)
        return [];
    for (const { reaction, sender } of reactions) {
        const isMine = sender.uid === currentUser.uid;
        if (!reactionMap.has(reaction)) {
            reactionMap.set(reaction, {
                reaction,
                count: 1,
                users: [sender],
                isMine,
            });
        }
        else {
            const entry = reactionMap.get(reaction);
            entry.count += 1;
            entry.users.push(sender);
            if (isMine)
                entry.isMine = true;
        }
    }
    return Array.from(reactionMap.values());
}
export const formatStyle = (timestamp, t, i18n) => {
    const now = Date.now();
    const diff = now - timestamp;
    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);
    if (seconds < 60)
        return t("time.justNow");
    if (minutes < 60)
        return t("time.minutesAgo", {
            count: minutes,
        });
    if (hours < 24)
        return t("time.hoursAgo", {
            count: hours,
        });
    if (days === 1)
        return t("time.yesterday");
    if (days < 7)
        return t("time.daysAgo", {
            count: days,
        });
    const date = new Date(timestamp);
    return date.toLocaleDateString(i18n.language, {
        day: "numeric",
        month: "long",
    });
};
const pluralize = (count, one, few, many) => {
    const mod10 = count % 10;
    const mod100 = count % 100;
    if (mod10 === 1 && mod100 !== 11)
        return one;
    if (mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14))
        return few;
    return many;
};
export function truncateText(text, maxLength = 25) {
    return text.length > maxLength
        ? text.slice(0, maxLength) + '...'
        : text;
}
export function createObjectUser(user) {
    return ({
        displayName: user.displayName,
        //photoURL: user.photoURL,
        uid: user.uid,
        email: user.email
    });
}
export function insertPipeBetweenLinks(str) {
    const urlPattern = '(https?:\\/\\/[^\\s]+)';
    const gluedRegex = new RegExp(urlPattern + '(?=' + urlPattern + ')', 'g');
    str = str.replace(gluedRegex, '$1 | ');
    const spacedRegex = new RegExp(urlPattern + '(\\s+)(?=' + urlPattern + ')', 'g');
    str = str.replace(spacedRegex, '$1 | ');
    return str;
}
export function createShareChatObj(options) {
    const messageID = uuidv4();
    const date = JSON.stringify(new Date());
    const { sender, shareChat } = options;
    const message = {
        shareChat: {
            displayName: shareChat.displayName,
            email: shareChat.email,
            uid: shareChat.uid,
            photoURL: shareChat.photoURL || ""
        },
        message: 'Контакт',
        messageID,
        date,
        sender
    };
    if (shareChat === null || shareChat === void 0 ? void 0 : shareChat.channel)
        message.shareChat.channel = createBaseObjectChannel(shareChat === null || shareChat === void 0 ? void 0 : shareChat.channel);
    return message;
}
export function generateShortId(length = 6) {
    const array = new Uint8Array(length);
    window.crypto.getRandomValues(array);
    return Array.from(array, byte => (byte % 36).toString(36)).join('');
}
